<div class="image-preview-content">
  @if (!imageError()) {
    <img
      [src]="imageUri()"
      (load)="onImageLoad($event)"
      (error)="onImageError($event)"
      class="fullscreen-image" />
  } @else {
    <div class="image-error">
      <i class="pi pi-exclamation-triangle"></i>
      <p>{{ 'imagePreview.errorMessage' | translate }}</p>
      <small>{{ 'imagePreview.errorDetails' | translate }}</small>
    </div>
  }
</div>
